const country = {
  country: "Pays",
  name: "Nom",
  schoolYearType: "Type d'année scolaire",
  defaultLanguage: "Langue par défaut",
  currency: "Devise",
  subscriptionPrice: "Prix de l'abonnement",
  saveCountryQuestion: "Enregistrer ce pays ?",
  saveCountryDescription:
    "Attention : le changement de devise et du prix de l'abonnement ne sera effectif que pour les nouveaux abonnements ou les renouvellements.",
  countryDetail: "Détails pays",
  countryCreation: "Création d'un pays",
  countries: "Pays",
};

export default country;
